import { cn } from '@library/component-utils/cn';

export interface MessageProps {
  className?: string;
  code?: 'ERROR' | 'SUCCESS' | '';
  message: string;
}

export const Message = ({
  className = 'px-5 text-lg leading-6',
  code = '',
  message
}: MessageProps) => {
  const getTextColor = () => {
    switch (code) {
      case 'ERROR':
        return 'text-roses';
      case 'SUCCESS':
        return 'text-atlien-200';
      default:
        return 'text-soFresh-100';
    }
  };
  return <p className={cn(getTextColor(), className)}>{message}</p>;
};
